import { Component } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-langs',
  templateUrl: './langs.component.html',
  styleUrls: ['./langs.component.scss'],
})
export class LangsComponent {
  showModal: boolean = false;

  preSelectedLang: "ru" | "us" = this.appSettings.selectedLang;

  constructor(public appSettings: SettingsService) {}

  modelForSelectLang() {
    this.showModal = !this.showModal;
  }

  public changeLang() {
    this.appSettings.selectedLang = this.preSelectedLang;
    this.appSettings.selectedLangSource.next();
    this.modelForSelectLang();
  }
}
